import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'send-btn',
	template: require('./send-btn.html'),
	styles: [require('./send-btn.scss')]
})
export class SendBtnComponent implements OnInit {
	@Input() text: string;
	@Input() isDisabled: boolean;
	@Input() addClass: any;
	btnText: string;

	constructor() {}

	ngOnInit() {
		this.btnText = this.text || 'Send';
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/buttons/send-btn/send-btn.ts